<div [formGroup]="reportGenerationForm" *ngIf="reportGenerationForm != null">
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label>Timeframe</label>
        <lib-date-range-picker formControlName="dateRange"></lib-date-range-picker>
      </div>
    </div>
  </div>
  <div
    class="row"
    *ngIf="
      reportGenerationForm.get('dateRange').errors?.['required'] &&
      reportGenerationForm.get('dateRange').touched
    ">
    <div class="col-12">
      <p class="error-text">You must choose both a begin date and an end date.</p>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <lib-checkbox
        label="Include Pickup/Successor Figures"
        formControlName="includePickupOrSuccessorFigures"></lib-checkbox>
    </div>
  </div>

  <lib-report-buttons
    [disabled]="reportGenerationForm.invalid"
    (generateReport)="generateReport()"
    (downloadReport)="downloadReport($event)"></lib-report-buttons>
</div>
